module.exports = __webpack_public_path__ + "static/media/web-logo.33085acb.svg";